import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "apps/front-office/client/App";
import { SiteContextProvider } from "components/SiteContext";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

const emotionCache = createCache({ key: "css" });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});
const dehydratedState = window.__REACT_QUERY_STATE__;

function Main() {
  React.useEffect(() => {
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <HydrationBoundary state={dehydratedState}>
        <CacheProvider value={emotionCache}>
          <Router>
            <SiteContextProvider>
              <App />
            </SiteContextProvider>
          </Router>
        </CacheProvider>
      </HydrationBoundary>
    </QueryClientProvider>
  );
}

// You cannot use hydrate because of Onboarding
// SSR will never display Onboarding
// Onboarding will be rendered client side only x times for each user / site
createRoot(document.querySelector("#root")).render(<Main />);
